import { render, staticRenderFns } from "./PackagesManagement.vue?vue&type=template&id=0d7ce442&scoped=true"
import script from "./PackagesManagement.vue?vue&type=script&lang=js"
export * from "./PackagesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ce442",
  null
  
)

export default component.exports